import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';

const Label = styled.label`
  color: #333333;
  display: block;
  font-family: ${props => props.theme.font.primary};
  font-size: .875rem;
  font-weight: bold;
  margin-bottom: 8px;
`;

const Input = styled.input`
  background: ${props => props.theme.input.background};;
  border: 1px solid ${props => props.error ? '#F44336' : '#DDDEE8'};
  border-radius: ${props => props.theme.input.borderRadius};
  color: #5a5a5a;
  font-family: ${props => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 300;
  opacity: ${props => props.disabled ? 0.4 : 1};
  padding: 12px;
  transition: 0.2s ease border, 0.2s ease box-shadow;
  width: 100%;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  &:hover {
    border: 1px solid ${props => props.error ? '#F44336' : props.theme.color.secondary};
  }

  &:focus {
    border: 1px solid ${props => props.error ? '#F44336' : props.theme.color.secondary};
    box-shadow: 0px 0px 0px 3px ${props => props.error ? '#FFBBB6D1' : `${props.theme.color.secondary}45`};
    outline: none;
  }

  @media(max-width: 900px) {
    padding: 8px;
  }
`;

const Spacer = styled.div`
  height: 16px;
  width: 0px;
`;
const Info = styled.span`
  font-size: .75rem;
  color: #555;
  margin-top: 2px;
`

const InputComponent = (props) => {
  return (
    <React.Fragment>
      <Label htmlFor={props.name}>{props.label}</Label>
      <Input 
        className={props.className}
        autoComplete={props.autoComplete} 
        error={props.error}
        id={props.name}
        name={props.name} 
        onChange={e => props.onChange(e.target.value)}
        placeholder={props.placeholder}
        onKeyPress={props.onKeyPress}
        value={props.value}
        type={props.type}
        disabled={props.disabled}
        step={props.step}
      />
      {props.info &&
        <Info>
          *{props.info}
        </Info>
      }
      <Spacer />
    </React.Fragment>
  )
}

InputComponent.propTypes = {
  autoComplete: PropTypes.string,
  error: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  type: PropTypes.string,
};


export default InputComponent